<app-content-page-layout title="Households">
  <!-- Add household button -->
  <div pageActions class="">
    <button
      (click)="openModal()"
      class="flex gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold rounded-lg transition"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Create
    </button>
  </div>
  <!-- Tabs -->
  <div class="sm:hidden">
    <select
      (change)="onSelectChange($event)"
      [value]="activeTab()"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
    >
      <option value="households" [selected]="activeTab() === 'households'">My households</option>
      <option value="invitations" [selected]="activeTab() === 'invitations'">Invitations</option>
    </select>
  </div>
  <ul
    class="hidden text-sm font-medium text-center text-gray-500 rounded-lg shadow-sm sm:flex dark:divide-gray-700 dark:text-gray-400"
  >
    <li class="w-full focus-within:z-10">
      <button
        (click)="setTab('households')"
        [ngClass]="
          activeTab() === 'households'
            ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white'
            : 'bg-white dark:bg-gray-800'
        "
        class="inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700 hover:text-gray-700 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 focus:outline-none transition rounded-s-lg"
        aria-current="page"
      >
        My households
      </button>
    </li>
    <li class="w-full focus-within:z-10">
      <button
        (click)="setTab('invitations')"
        [ngClass]="
          activeTab() === 'invitations'
            ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white'
            : 'bg-white dark:bg-gray-800'
        "
        class="inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700 hover:text-gray-700 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 focus:outline-none transition rounded-e-lg"
      >
        Invitations
      </button>
    </li>
  </ul>
  <!-- Tab Content -->
  <div class="mt-8">
    <!-- Households List -->
    @if (activeTab() === 'households') {
      @if (households.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (household of households; track household.id) {
            <div class="flex items-center justify-between rounded-2xl">
              <!-- Avatar -->
              <app-avatar
                [imageSrc]="'https://picsum.photos/200/300'"
                [username]="household.name"
                subtitle="Subtitle"
              ></app-avatar>
              <!-- Button Elements -->
              <div class="flex gap-2">
                <button
                  [routerLink]="['/app/households/manage']"
                  [queryParams]="{ id: household.id }"
                  class="px-3 py-1 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition"
                >
                  Manage
                </button>
              </div>
            </div>
          }
        </ul>
      } @else {
        <div class="flex items-center justify-center h-48">
          <h1 class="text-gray-400 text-2xl font-bold text-center">
            You're not member of a household yet
          </h1>
        </div>
      }
    }
    <!-- Invitations -->
    @else if (activeTab() === 'invitations') {
      @if (invitations.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (invitation of invitations; track invitation.id) {
            <div class="flex items-center justify-between rounded-2xl">
              <!-- Avatar -->
              <app-avatar
                [imageSrc]="'https://picsum.photos/200/300'"
                [username]="invitation.household_name"
                subtitle="Subtitle"
              ></app-avatar>
              <!-- Button Elements -->
              <div class="flex gap-2">
                <button
                  (click)="respondToInvitation(invitation.invitation_id, true)"
                  class="px-3 py-1 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition"
                >
                  Accept
                </button>
                <button
                  (click)="respondToInvitation(invitation.invitation_id, false)"
                  class="px-3 py-1 text-sm font-semibold bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white hover:bg-gray-300 text-black rounded-lg transition"
                >
                  Decline
                </button>
              </div>
            </div>
          }
        </ul>
      } @else {
        <div class="flex items-center justify-center h-48">
          <h1 class="text-gray-400 text-2xl font-bold text-center">No invitations</h1>
        </div>
      }
    }
    <!-- Fall-back -->
    @else {
      <div class="flex items-center justify-center h-48">
        <h1 class="text-gray-400 text-2xl font-bold text-center">Nothing to see here</h1>
      </div>
    }
  </div>
</app-content-page-layout>
<!-- Create Household Modal -->
@if (modalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/40" (click)="modalOpen = false"></div>
    <!-- Dialog -->
    <div
      class="relative w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700"
    >
      <h2 class="text-lg font-bold text-gray-800 dark:text-white mb-4">Create Household</h2>

      <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Name</label>
      <input
        type="text"
        [(ngModel)]="modalHouseholdName"
        placeholder="Enter name"
        autocomplete="off"
        (keydown.enter)="createHousehold()"
        class="w-full px-3 py-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white mb-3"
      />

      @if (modalError) {
        <p class="text-red-600 text-xs mb-3">{{ modalError }}</p>
      }

      <div class="flex gap-2 justify-end">
        <button
          (click)="modalOpen = false"
          class="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 dark:bg-gray-600 dark:text-white rounded-lg hover:bg-gray-200 dark:hover:bg-gray-500 transition"
        >
          Cancel
        </button>
        <button
          (click)="createHousehold()"
          [disabled]="modalLoading || !modalHouseholdName.trim()"
          class="px-4 py-2 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ modalLoading ? 'Creating...' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
}
